<template>
  <section>
    <div :key="commonStore.resetKey" class="main-layout">
      <TopNavHeader />
      <main>
        <slot />
      </main>
      <TopNavFooter v-show="!configStore.isMobileMenu" />
    </div>
  </section>
</template>

<script lang="ts" setup>
  import TopNavFooter from '@/components/templates/top-nav/TopNavFooter.vue';
  import TopNavHeader from '@/components/templates/top-nav/TopNavHeader.vue';
  import { useCommonStore } from '@/stores/common';
  import { useConfigStore } from '@/stores/config';
  import { onBeforeMount } from 'vue';
  import { useRouter } from 'vue-router';

  const router = useRouter();
  const commonStore = useCommonStore();
  const configStore = useConfigStore();

  onBeforeMount(async () => {
    // 필수값 체크
    if (!configStore.config.StoreID || !configStore.config.SubStoreCode) {
      router.replace('/login');
      return;
    }
  });
</script>
